import Vue from 'vue';
import PriceCalculator from './PriceCalculator.vue';
import Vuex from 'vuex';
import VueSweetalert2 from 'vue-sweetalert2';
import store from '@/store';
import Element from 'element-ui';
import config from '@/config';
// import VueGtag from "vue-gtag";
import { VueReCaptcha } from 'vue-recaptcha-v3';

import '@/theme/index.css';
import '@/assets/css/main.scss';

Vue.use(Vuex);
Vue.use(VueSweetalert2);
Vue.use(VueReCaptcha, { siteKey: '6Lc0i4YUAAAAABEE-5JRFKOnwlDA9FGf_yI6h7tD' });
// Vue.use(VueGtag, {
//   config: { id: "G-GEG4H90V35" },
// });
Vue.use(Element);

Vue.config.productionTip = false;
Vue.prototype.$config = config;
new Vue({
  store,
  render: h => h(PriceCalculator)
}).$mount('#app');
